import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	getCategorySummaryData,
	getDashboardFilters,
} from "../../queries/apiQueries";
import { CheckPicker, Checkbox, SelectPicker } from "rsuite";
import "./profitability.scss";
import Summary from "./summary";
import Details from "./details";
import {
	CURRENTVIEW,
	FILTERDATA,
	TIMELINE,
	numberFormatter,
} from "../../utils";
import { useNavigate } from "react-router-dom";
import {
	topSupplierCount,
	addressableSpend,
} from "../constants";
import { appInsights } from "../router";
import MainHeader from "../../components/Layouts/MainHeader";
import ToggleSwitch from "../../components/common/ToggleSwitch";
import MainContent from "../../components/Layouts/MainContent";
import html2canvas from "html2canvas";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { CSVLink } from "react-csv";
import { Segmented } from "antd";
import { Loader } from "../../components/common/Loader";
import { getTimelineOptions } from "../../config/constants";
const CategoryProfitability = (props: any) => {
	const footerStyles = {
		padding: "10px 2px",
		borderTop: "1px solid #e5e5e5",
	};
	const timelineOptions=getTimelineOptions()

	const currentView = useSelector(
		(state: any) => state.CommonReducer.currentView
	);
	const allFilters = useSelector(
		(state: any) => state.CommonReducer.allFilters
	);
	const timeline = useSelector((state: any) => state.CommonReducer.timeline);
	const token = useSelector((state: any) => state.CommonReducer.token);
	var isCleared = false;
	const didMount: any = useRef(false);
	const dispatch = useDispatch<any>();
	const [filtersLoading, setFiltersLoading] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [filterOptions, updateFilterOptions] = useState<any>({
		district: new Array<{ district: string }>(),
		l1: new Array<{ l1: string }>(),
		l2: new Array<{ l2: string }>(),
		l3: new Array<{ l3: string }>(),
		supplier: new Array<{ vendor: string }>(),
	});
	const [selectedFilters, setSelectedFilters] = useState<any>(allFilters);
	const navigate = useNavigate();
	const [isVisible, setIsVisible] = useState(false);
	const [summaryView, setSummaryView] = useState(currentView?.isSummaryView);
	const [summaryFlag, setSummaryFlag] = useState<any>(true);

	const [allExportData, setAllExportData] = useState<any>([]);
	const [viewBy, setViewBy] = useState(currentView?.viewBy);

	const [summaryData, setSummaryData] = useState<any>(null);

	const [summaryDataRes, setSummaryDataRes] = useState<any>(null);

	const [summaryLoading, setSummaryLoading] = useState(true);

	const [dashboardKpi, setDashboardKpi] = useState<any>(null);
	const [selectedRecommendationItem, setSelectedRecommendationItem] =
		useState<string | null>(currentView?.selectedHighlight);
	const [highlight, setHighlight] = useState<any>(
		currentView?.selectedHighlight
	);

	const [selectedTimeline, setSelectedTimeline] = useState(
		timeline ? timeline : getTimelineOptions()[0]?.value
	);
	const [selectedAddressableSpend, setSelectedAddressableSpend] = useState(
		addressableSpend.length && addressableSpend[0].value
	);

	const [selectedSupplierCount, setSelectedSupplierCount] = useState(
		topSupplierCount[0].value
	);

	const [currentViewState, setCurrentViewState] = useState<{
		isSummaryView: boolean;
		viewBy: string;
		selectedHighlight: null | string;
		filters: {
			district: Array<any>;
			l1: Array<any>;
			l2: Array<any>;
			l3: Array<any>;
			supplier: Array<any>;
		};
	}>(currentView);

	const didMount2: any = useRef(false);

	const filtersMount: any = useRef(false);
	const [exportDataSorted, setExportDataSorted] = useState([]);
	const [exportHeader, setExportHeader] = useState<any>([]);
	const exportFullRef = useRef<any>(null);
	const [viewFor, setViewFor] = useState([]);
	const [isRightVisible, setIsRightVisible] = useState(false);
	const supplierConutHandler = (e: any) => {
		setSelectedSupplierCount(e === null ? null : e);
	};

	const downloadScreenshot = async () => {
		const element = document.getElementById("capture-area");
		if (element) {
			const canvas = await html2canvas(element);
			const image = canvas.toDataURL("image/png");
			const link = document.createElement("a");
			link.href = image;
			link.download = "screenshot.png";
			link.click();
		}
	};

	useEffect(() => {
		let filterView = viewBy === "Supplier" ? "master_vendor_name" : viewBy;
		let index = allExportData?.findIndex((e: any) => e?.key === filterView);
		if (index !== -1) {
			setExportDataSorted(allExportData[index]?.data);
			setExportHeader([
				{ label: viewBy, key: "category" },
				{ label: "Spend ($)", key: "cost" },
				{ label: "Sales ($)", key: "revenue" },
				{ label: "5 Year CAGR", key: "cagr" },
				{ label: "Gross Margin", key: "grossMargin" },
			]);
		}
	}, [viewBy, allExportData]);

	useEffect(() => {
		appInsights.trackPageView({
			name: `Navigate to Category Profitability by ${localStorage.getItem(
				"name"
			)}`,
		});
		if (didMount2.current) {
			props.onUpdatingCurrentView(currentViewState);
		} else {
			didMount2.current = true;
		}
	}, [currentViewState]);

	const getSummaryData = async (payload: any = null) => {
		// setIsLoading(true);
		setSummaryLoading(true);
		payload = { ...selectedFilters, ...payload };
		if (!payload) {
			payload = {
				vendor_name: [],
				l1: [],
				l2: [],
				l3: [],
				district: [],
				timeline: selectedTimeline,
				topData: selectedSupplierCount,
			};
		} else {
			payload.vendor_name = payload.supplier;
			payload.timeline = selectedTimeline;
			payload.topData = selectedSupplierCount;

			// delete payload.supplier;
		}
		payload.nofInd = selectedAddressableSpend;
		let res = await dispatch(getCategorySummaryData(payload));
		setSummaryDataRes(res);
		setDashboardKpi(res?.overallSummary);
		if (viewBy == "Supplier") {
			setSummaryData(res.master_vendor_name);
			if (currentView.selectedHighlight) {
				setDashboardKpi(
					res.master_vendor_name.scatterData.filter(
						(data: any) =>
							data.category == currentView.selectedHighlight
					)[0]
				);
			}
		} else {
			setSummaryData(res[viewBy]);
			if (currentView.selectedHighlight) {
				setDashboardKpi(
					res[viewBy].scatterData.filter(
						(data: any) =>
							data.category == currentView.selectedHighlight
					)[0]
				);
			}
		}
		structureExportData(res);
		// setIsLoading(false);
		setSummaryLoading(false);
	};

	const structureExportData = (data: any) => {
		let finalData: any = [];
		for (const key in data) {
			if (key !== "overallSummary") {
				let preparedData: any = [];
				data[key]?.scatterData?.forEach((val: any) => {
					let obj = {
						category: val?.category,
						cost: val?.cost,
						revenue: val?.revenue,
						cagr: `${(val?.scatterData?.cagr * 100).toFixed(2)}%`,
						grossMargin: `${val?.scatterData?.grossMargin * 100}%`,
					};
					preparedData.push(obj);
				});
				finalData.push({ key: key, data: preparedData });
			}
		}
		setAllExportData(finalData);
	};

	/* Filters api call */
	const getFilters = async (
		payload: any = {},
		currentFilter: any = "all",
		fo: any = null
	) => {
		setFiltersLoading(true);
		if (payload.supplier) {
			payload.vendor_name = payload.supplier;
			// delete payload.supplier;
		}
		let res = await dispatch(getDashboardFilters(payload));
		setTimeout(() => {
			setFiltersLoading(false);
		}, 100);
		if (fo) {
			fo.supplier = fo.suppliers;
			fo.district = fo.districts;
			delete fo.districts;
			delete fo.suppliers;
			if (currentFilter === "district") {
				updateFilterOptions({
					...fo,
					l1: [...res.l1],
					l2: [...res.l2],
					l3: [...res.l3],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l1") {
				updateFilterOptions({
					...fo,
					l2: [...res.l2],
					l3: [...res.l3],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...fo,
					l3: [...res.l3],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({ ...fo, supplier: [...res.suppliers] });
			} else if (currentFilter === "supplier") {
				updateFilterOptions({ ...fo });
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
					district: res.districts,
					supplier: res.suppliers,
				});
			}
		} else {
			if (currentFilter === "district") {
				updateFilterOptions({
					...filterOptions,
					l1: [...res.l1],
					l2: [...res.l2],
					l3: [...res.l3],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l1") {
				updateFilterOptions({
					...filterOptions,
					l2: [...res.l2],
					l3: [...res.l3],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...filterOptions,
					l3: [...res.l3],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({
					...filterOptions,
					supplier: [...res?.suppliers],
				});
			} else if (currentFilter === "supplier") {
				updateFilterOptions({ ...filterOptions });
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
					district: res.districts,
					supplier: res.suppliers,
				});
			}
		}
		setIsLoading(false);
		filtersMount.current = false;
		// setSelectedRecommendationItem(null);
		return res;
	};

	/* Updating filter selection state  */
	const handleFilterUpdate = (value: any, filter: string) => {
		if (isCleared) {
			isCleared = false;
			return;
		}
		filtersMount.current = true;
		let x: string = filter;
		if (value === "all") {
			if (filterOptions?.[x].length === selectedFilters?.[x].length) {
				setSelectedFilters({ ...selectedFilters, [x]: [] });
			} else {
				if (x == "supplier") {
					setSelectedFilters({
						...selectedFilters,
						[x]: [
							...filterOptions?.[x].map(
								(option: any) => option.vendor
							),
						],
					});
				} else {
					setSelectedFilters({
						...selectedFilters,
						[x]: [
							...filterOptions?.[x].map(
								(option: any) => option?.[x]
							),
						],
					});
				}
			}
		} else {
			setSelectedFilters({ ...selectedFilters, [x]: [...value] });
			// setSelectedFilters({})
		}
		setSelectedRecommendationItem(null);
	};

	/* Updating filter options based on selection (api) */
	const handleClose = (filter: string) => {
		if (filter === "district") {
			setSelectedFilters({
				...selectedFilters,
				l1: [],
				l2: [],
				l3: [],
				supplier: [],
			});
			getFilters(
				{ ...selectedFilters, l1: [], l2: [], l3: [], supplier: [] },
				"district"
			);
			getSummaryData({
				...selectedFilters,
				l1: [],
				l2: [],
				l3: [],
				supplier: [],
			});
		} else if (filter === "l1") {
			setSelectedFilters({
				...selectedFilters,
				l2: [],
				l3: [],
				supplier: [],
			});
			getFilters(
				{ ...selectedFilters, l2: [], l3: [], supplier: [] },
				"l1"
			);
			getSummaryData({
				...selectedFilters,
				l2: [],
				l3: [],
				supplier: [],
			});
		} else if (filter === "l2") {
			setSelectedFilters({ ...selectedFilters, l3: [], supplier: [] });
			getFilters({ ...selectedFilters, l3: [], supplier: [] }, "l2");
			getSummaryData({ ...selectedFilters, l3: [], supplier: [] });
		} else if (filter === "l3") {
			setSelectedFilters({ ...selectedFilters, supplier: [] });
			getFilters({ ...selectedFilters, supplier: [] }, "l3");
			getSummaryData({ ...selectedFilters, supplier: [] });
		} else if (filter === "supplier") {
			getFilters({ ...selectedFilters }, "supplier");
			getSummaryData({ ...selectedFilters });
		}
	};

	const handleClear = (filter: string) => {
		isCleared = true;
		if (filter === "district") {
			setSelectedFilters({
				district: [],
				l1: [],
				l2: [],
				l3: [],
				supplier: [],
			});

			getFilters(
				{ district: [], l1: [], l2: [], l3: [], supplier: [] },
				"district"
			);
			getSummaryData({
				district: [],
				l1: [],
				l2: [],
				l3: [],
				supplier: [],
			});
		} else if (filter === "l1") {
			setSelectedFilters({
				...selectedFilters,
				l1: [],
				l2: [],
				l3: [],
				supplier: [],
			});
			getFilters(
				{ ...selectedFilters, l1: [], l2: [], l3: [], supplier: [] },
				"l1"
			);
			getSummaryData({
				...selectedFilters,
				l1: [],
				l2: [],
				l3: [],
				supplier: [],
			});
		} else if (filter === "l2") {
			setSelectedFilters({
				...selectedFilters,
				l2: [],
				l3: [],
				supplier: [],
			});
			getFilters(
				{ ...selectedFilters, l2: [], l3: [], supplier: [] },
				"l2"
			);
			getSummaryData({
				...selectedFilters,
				l2: [],
				l3: [],
				supplier: [],
			});
		} else if (filter === "l3") {
			// handleClose('l2');
			setSelectedFilters({ ...selectedFilters, l3: [], supplier: [] });
			getFilters({ ...selectedFilters, l3: [], supplier: [] }, "l3");
			getSummaryData({ ...selectedFilters, l3: [], supplier: [] });
		} else if (filter === "supplier") {
			setSelectedFilters({ ...selectedFilters, supplier: [] });
			getFilters({ ...selectedFilters, supplier: [] }, "supplier");
			getSummaryData({ ...selectedFilters, supplier: [] });
		}
	};

	useEffect(() => {
		props.onFilterChange(selectedFilters);
		if (didMount.current) {
			setCurrentViewState({
				...currentViewState,
				filters: selectedFilters,
			});
		}
	}, [selectedFilters]);

	useEffect(() => {
		props.onTimelineChange(selectedTimeline);
		if (token) {
			if (selectedTimeline || selectedAddressableSpend) {
				getSummaryData();
			}
		}
	}, [selectedTimeline, selectedAddressableSpend]);

	useEffect(() => {
		if (token) {
			getSummaryData();
		}
	}, [selectedSupplierCount]);

	useEffect(() => {
		if (token) {
			if (!didMount.current) {
				getFilters().then((options: any) => {
					if (selectedFilters?.supplier.length > 0) {
						getFilters(selectedFilters, "supplier", options);
					} else if (selectedFilters?.l3.length > 0) {
						getFilters(selectedFilters, "l3", options);
					} else if (selectedFilters?.l2.length > 0) {
						getFilters(selectedFilters, "l2", options);
					} else if (selectedFilters?.l1.length > 0) {
						getFilters(selectedFilters, "l1", options);
					} else if (selectedFilters?.district.length > 0) {
						getFilters(selectedFilters, "district", options);
					}
				});

				// props.currentView({ isSummaryView: false, selectedHighlight: recommendation });

				// setSummaryView(currentView.isSummaryView);
				// setViewBy(currentView.viewBy);
				getSummaryData();
				setFiltersLoading(false);
				didMount.current = true;
			}
		}
	}, [currentView, token]);

	useEffect(() => {
		if (token) {
			if (summaryDataRes) {
				if (viewBy == "Supplier") {
					setSummaryData(summaryDataRes.master_vendor_name);
				} else {
					setSummaryData(summaryDataRes[viewBy]);
				}
				setDashboardKpi(summaryDataRes.overallSummary);
				setHighlight(null);
				// setSelectedRecommendationItem(null);
				// props.currentView({ selectedHighlight: null });
			}
		}
	}, [viewBy]);

	const updateFiltersOnNavigation = (value: string, page: string) => {
		if (viewBy == "Supplier") {
			props.onFilterChange({ ...selectedFilters, supplier: [value] });
		} else if (viewBy == "District") {
			props.onFilterChange({ ...selectedFilters, district: [value] });
		} else if (viewBy == "L1") {
			props.onFilterChange({ ...selectedFilters, l1: [value] });
		} else if (viewBy == "L2") {
			props.onFilterChange({ ...selectedFilters, l2: [value] });
		} else if (viewBy == "L3") {
			props.onFilterChange({ ...selectedFilters, l3: [value] });
		}
		if (page) {
			navigate(page);
		}
	};

	const updateHighlight = (value: any) => {
		setHighlight(value);
		setCurrentViewState({ ...currentViewState, selectedHighlight: value });
		// props.onUpdatingCurrentView({ selectedHighlight: value });
		if (value == null) {
			setDashboardKpi(summaryDataRes.overallSummary);
		} else {
			setDashboardKpi(
				summaryData.scatterData.filter(
					(data: any) => data.category == value
				)[0]
			);
		}
	};

	/* on changing timeline */
	const timelineHandler = (e: any) => {
		setSelectedTimeline(e === null ? "All" : e);
	};

	/* on changing addressable spend type */
	const addressableSpendHandler = (e: any) => {
		setSelectedAddressableSpend(e === null ? "All" : e);
	};
	const switchView = (isSummaryView: boolean) => {
		setSelectedRecommendationItem(null);
		setSummaryView(isSummaryView);
		setHighlight(null);
		setCurrentViewState({
			...currentViewState,
			isSummaryView: isSummaryView,
			selectedHighlight: null,
		});
		// props.onUpdatingCurrentView({ isSummaryView: isSummaryView, selectedHighlight: null });
		setDashboardKpi(summaryDataRes.overallSummary);
	};

	return isLoading ? (
		<Loader />
	) : (
		<div className="profitability-container w-full">
			<MainHeader
				onVisibilityChange={setIsVisible}
				isRightVisible={isRightVisible}
				setIsRightVisible={setIsRightVisible}
				topContent={
					<>
						<div className="flex justify-between items-center w-full">
							<div className="text-left pageline">
								<span className="pagelinestart">
									Category Stratergy Recommendation
								</span>{" "}
								<span className="pagelineslash">/</span>{" "}
								<span className="pagelinesub">
									Category Profitability
								</span>
							</div>
						</div>
						<div className="execution-level-wrapper">
							<div className="execution-level-title">View By</div>

							<Segmented
								options={["Summary", "Details"]}
								value={summaryView ? "Summary" : "Details"}
								onChange={(value) => {
									const isSummaryView = value === "Summary";
									switchView(isSummaryView);
								}}
							/>
						</div>
					</>
				}
				bottomContent={
					<>
						<div className="sub-heading-text font-bold flex flex-col items-start">
							<span className="filterHead ">Timeline</span>
							<SelectPicker
								data={
									timelineOptions.length
										? timelineOptions
										: []
								}
								placeholder="All"
								
								value={selectedTimeline}
								defaultValue={
									timelineOptions.length
										? timelineOptions[0].value
										: ""
								}
								onChange={timelineHandler}
								cleanable={false}
							/>
						</div>
						{selectedFilters &&
							["district", "l1", "l2", "l3", "supplier"].map(
								(filterEntity: string) => (
									<div
										key={filterEntity}
										className="sub-heading-text font-bold flex flex-col items-start"
									>
										<span className="filterHead ">
											{filterEntity}
										</span>
										<CheckPicker
											data={
												filterOptions[filterEntity]
													?.length
													? filterOptions[
															filterEntity
													  ]
													: []
											}
											placeholder="All"
											labelKey={
												filterEntity === "supplier"
													? "vendor"
													: filterEntity
											}
											valueKey={
												filterEntity === "supplier"
													? "vendor"
													: filterEntity
											}
											value={
												selectedFilters[filterEntity] ||
												[]
											}
											onClose={() =>
												filtersMount.current
													? handleClose(filterEntity)
													: ""
											}
											onClean={() =>
												handleClear(filterEntity)
											}
											onChange={(value: any) =>
												handleFilterUpdate(
													value,
													filterEntity
												)
											}
											virtualized
											loading={filtersLoading}
											style={{ width: "100%" }}
										/>
									</div>
								)
							)}
						<div className="sub-heading-text font-bold flex flex-col items-start">
							<span className="filterHead">
								Addressable Spend
							</span>
							<SelectPicker
								data={
									addressableSpend.length
										? addressableSpend
										: []
								}
								placeholder="All"
								value={selectedAddressableSpend}
								
								defaultValue={
									addressableSpend.length
										? addressableSpend[0].value
										: ""
								}
								onChange={addressableSpendHandler}
								cleanable={false}
							/>
						</div>
					</>
				}
			></MainHeader>

			<MainContent isVisible={isVisible} fullHeight={true}>
				{dashboardKpi && (
					<div className="flex flex-col items-center w-full">
						<div className="flex justify-between gap-5 w-full mb-2">
							<div className="infocard">
								<div className="infocardHead">
									<span className="headerText">Spend</span>
								</div>
								<div className="contentText">
									{numberFormatter(dashboardKpi.cost, 
										dashboardKpi?.cost > 100000000 ? 1:
										0, "$")}
								</div>
							</div>
							<div className="infocard">
								<div className="infocardHead">
									<span className="headerText">Sales</span>
								</div>
								<div className="contentText">
									{numberFormatter(
										dashboardKpi.revenue,
										dashboardKpi?.revenue > 100000000 ? 1:
										0,
										"$"
									)}
								</div>
							</div>
							<div className="infocard">
								<div className="infocardHead">
									<span className="headerText">
										Gross Margin
									</span>
								</div>
								<div className="contentText">
									{numberFormatter(
										dashboardKpi.scatterData.grossMargin *
											100,
										2
									)}
									%
								</div>
							</div>
							<div className="infocard">
								<div className="infocardHead">
									<span className="headerText">
										5 Year CAGR
									</span>
								</div>
								<div className="contentText">
									{numberFormatter(
										dashboardKpi.scatterData.cagr * 100,
										2
									)}
									%
								</div>
							</div>
							<div className="infocard">
								{viewBy !== "Supplier" && (
									<>
										<div className="infocardHead">
											<span className="headerText">
												# Supplier
											</span>
										</div>
										<div className="contentText">
											{Array.isArray(
												dashboardKpi.suppliers
											)
												? dashboardKpi.suppliers.length
												: dashboardKpi.suppliers}
										</div>
									</>
								)}
								{viewBy === "Supplier" && (
									<>
										<div className="infocardHead">
											<span className="headerText">
												NIA Earnings
											</span>
										</div>
										<div className="contentText">
											{dashboardKpi?.niaEarnings >= 0
												? numberFormatter(
														dashboardKpi?.niaEarnings,
														dashboardKpi?.niaEarnings > 100000000 ? 1 :
														0,
														dashboardKpi?.niaEarnings >
															0
															? "$"
															: ""
												  )
												: "-"} ({numberFormatter(dashboardKpi?.niaPercent*100,2)}%)
										</div>
									</>
								)}
							</div>
						</div>
					</div>
				)}

				<div className="contentBox !pb-0 pt-[1vh]">
					<div
						className={`flex flex-col ${
							isVisible ? "h-[52vh]" : "h-[64vh]"
						}`}
					>
						<div className="contentHeader !h-[7vh]">
							{/* Left side - Filter div */}
							<div></div>
							<div></div>
							<div className="flex mb-[20px]">
								{viewBy === "Supplier" && (
									<div className="mr-[1vw]">
										<div className="sub-heading-text font-semibold flex flex-col items-start">
											<span className="textNormal text-black">
												No. of Suppliers
											</span>
											<SelectPicker
												style={{
													width: "8vw",
													height: "2vh",
												}}
												data={
													topSupplierCount.length
														? topSupplierCount
														: []
												}
												placeholder="All"
												
												value={selectedSupplierCount}
												defaultValue={
													topSupplierCount.length
														? topSupplierCount[0]
																.value
														: ""
												}
												onChange={supplierConutHandler}
												cleanable={false}
											/>
										</div>
									</div>
								)}
								{(selectedSupplierCount !== 10 ||
									(selectedSupplierCount === 10 &&
										viewBy !== "Supplier")) && (
									<div className="mr-[1vw]">
										<div className="sub-heading-text font-semibold flex flex-col items-start">
											<span className="textNormal text-black">{`Highlight ${viewBy}`}</span>
											<SelectPicker
												data={
													filterOptions[
														viewBy.toLowerCase()
													]?.length
														? filterOptions[
																viewBy.toLowerCase()
														  ]
														: []
												}
												placeholder="All"
												labelKey={
													viewBy.toLowerCase() ===
													"supplier"
														? "vendor"
														: viewBy.toLowerCase()
												}
												valueKey={
													viewBy.toLowerCase() ===
													"supplier"
														? "vendor"
														: viewBy.toLowerCase()
												}
												onChange={(value) => {
													updateHighlight(value);
												}}
												style={{
													width: "8vw",
													height: "2vh",
												}}
											/>
										</div>
									</div>
								)}
								{((selectedSupplierCount === 10 &&
									viewBy === "Supplier") ||
									viewBy === "District") && (
									<div className="mr-[1vw]">
										<div>
											<div className="sub-heading-text font-semibold flex flex-col items-start">
											</div>
										</div>
									</div>
								)}
								<div>
									<div className="flex mt-[3vh]">
										<FileDownloadIcon
											className="mt-[0.1vw] cursor-pointer"
											style={{
												background: "#9acd32b8",
												borderRadius: ".3vh",
											}}
											onClick={() => {
												exportFullRef?.current?.link.click();
											}}
										></FileDownloadIcon>
										<CSVLink
											data={exportDataSorted}
											headers={exportHeader}
											filename="CategoryProfitibility.csv"
											target="_blank"
											ref={exportFullRef}
											className="hidden"
										></CSVLink>
										{((viewBy === "Supplier" &&
											selectedSupplierCount === 10) ||
											viewBy === "District") && (
											<CameraAltIcon
												className="ml-2 mt-[0.1vw] cursor-pointer"
												style={{
													background: "#9acd32b8",
													borderRadius: ".3vh",
												}}
												onClick={() => {
													downloadScreenshot();
												}}
											></CameraAltIcon>
										)}
									</div>
								</div>
							</div>

							{/* Right side - Buttons wrapped in a div */}
							<div className="flex">
								<div className="execution-level-wrapper">
									<div className="execution-level-title">
										View
									</div>
									<Segmented
										options={[
											"Supplier",
											"District",
											"L1",
											"L2",
											"L3",
										]}
										value={viewBy}
										onChange={(value) => {
											setViewBy(value);
											setSelectedRecommendationItem(null);
											setCurrentViewState({
												...currentViewState,
												viewBy: value,
											});
										}}
									/>
								</div>
							</div>
						</div>

						{summaryLoading ? (
							<Loader />
						) : (
							<>
								<div className="flex-grow w-full text-[0.85em]">
									{summaryView && summaryData ? (
										<Summary
											isVisible={isVisible}
											summaryView={summaryView}
											data={summaryData}
											exportData={allExportData}
											view={viewBy}
											selected={
												selectedRecommendationItem
											}
											recommended={null}
											filters={filterOptions}
											handleClick={(
												recommendation: string | null
											) => {
												setSelectedRecommendationItem(
													recommendation
												);
												setSummaryView(false);
												updateHighlight(recommendation);
												setCurrentViewState({
													...currentViewState,
													isSummaryView: false,
													selectedHighlight:
														recommendation,
												});
											}}
											highlight={highlight}
											updateHighlight={(value: any) => {
												updateHighlight(value);
												setCurrentViewState({
													...currentViewState,
													selectedHighlight: value,
												});
											}}
											selectedSupplierCount={
												selectedSupplierCount
											}
											updateSelectedSupplierCount={(
												value: any
											) => {
												setSelectedSupplierCount(value);
											}}
											viewFor={viewFor}
											setViewFor={setViewFor}
										/>
									) : (
										summaryData && (
											<div className="w-full text-[0.85em]">
												<Details
													isVisible={isVisible}
													summaryView={summaryView}
													data={summaryData}
													selectedTimeline={
														selectedTimeline
													}
													selectedFilters={
														selectedFilters
													}
													summaryFlag={summaryFlag}
													updateSummaryFlag={(
														data: any
													) => setSummaryFlag(data)}
													view={viewBy}
													recommended={
														selectedRecommendationItem
													}
													filters={filterOptions}
													handleClick={(
														recommended:
															| string
															| null
													) => {
														setSelectedRecommendationItem(
															recommended
														);
														updateHighlight(
															recommended
														);
														setCurrentViewState({
															...currentViewState,
															selectedHighlight:
																recommended,
														});
													}}
													updateFilters={(
														value: string,
														route: string
													) =>
														updateFiltersOnNavigation(
															value,
															route
														)
													}
												></Details>
											</div>
										)
									)}
								</div>
							</>
						)}
						<div className="contentFooter">
							<div className="flex space-x-2 ml-auto pr-2">
								<div className="flex items-center">
									<div
										className="w-3 h-3 mr-1"
										style={{ backgroundColor: "#EAA61482" }}
									></div>
									<span
										className="text-[0.85em]"
										style={{ color: "#EAA614" }}
									>
										Grow Market Share
									</span>
								</div>
								<div className="flex items-center">
									<div
										className="w-3 h-3 mr-1"
										style={{ backgroundColor: "#DA505582" }}
									></div>
									<span
										className="text-[0.85em]"
										style={{ color: "#DA5055" }}
									>
										Re-Access and Fix
									</span>
								</div>
								<div className="flex items-center">
									<div
										className="w-3 h-3 mr-1"
										style={{ backgroundColor: "#86BC2582" }}
									></div>
									<span
										className="text-[0.85em]"
										style={{ color: "#86BC25" }}
									>
										Protect and Expand
									</span>
								</div>
								<div className="flex items-center">
									<div
										className="w-3 h-3 mr-1"
										style={{ backgroundColor: "#62B5E582" }}
									></div>
									<span
										className="text-[0.85em]"
										style={{ color: "#62B5E5" }}
									>
										Improve Margin
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</MainContent>
		</div>
	);
};

const mapDispatchToProps = (dispatch: any) => ({
	onFilterChange: (data: any) => dispatch({ type: FILTERDATA, data: data }),
	onUpdatingCurrentView: (data: any) =>
		dispatch({ type: CURRENTVIEW, data: data }),
	onTimelineChange: (data: any) => dispatch({ type: TIMELINE, data: data }),
});

export default connect(null, mapDispatchToProps)(CategoryProfitability);
